import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../../lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-[var(--font-size-xs)] font-[var(--font-weight-semibold)] transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 font-[var(--font-family-primary)]",
  {
    variants: {
      variant: {
        // Amazon Design System Primary - Orange
        default:
          "border-transparent bg-[var(--amazon-orange)] text-white hover:bg-[var(--amazon-orange-hover)]",
        // Amazon Design System Secondary - Dark Blue
        secondary:
          "border-transparent bg-[var(--amazon-dark-blue)] text-white hover:bg-[var(--amazon-dark-blue)]/90",
        // Destructive - Error state
        destructive:
          "border-transparent bg-[var(--error-color)] text-white hover:bg-[var(--error-color)]/90",
        // Outline - Amazon Orange border
        outline: "border-[var(--amazon-orange)] text-[var(--amazon-orange)] bg-white hover:bg-[var(--amazon-orange)]/10",
        // Success - Green
        success:
          "border-transparent bg-[var(--success-color)] text-white hover:bg-[var(--success-color)]/90",
        // Warning - Yellow/Orange
        warning:
          "border-transparent bg-[var(--warning-color)] text-[var(--amazon-dark-blue)] hover:bg-[var(--warning-color)]/90",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }